import { OrderMockup } from "../Order/OrderMockup";
import { PodOrderMockupApi } from "./PodOrder";

export type PodOrderMockupPreviewLine = {
  order_id: number;
  product_id: number;
  sku?: string | null;
  product_name?: string | null;
};

export const mapPodOrderMockupsToOrderMockups = (
  mockups: PodOrderMockupApi[],
  orderId: number,
  productId: number,
): OrderMockup[] =>
  mockups.map(mockup => ({
    id: mockup.id,
    order_id: mockup.order_id ?? orderId,
    product_id: mockup.product_id ?? productId,
    image_url: mockup.image_url,
    approved: mockup.approved,
    approved_date: mockup.approved_date ? new Date(mockup.approved_date) : undefined,
    changes_requested: 0,
    is_rejected: false,
    created_date: mockup.created_date ? new Date(mockup.created_date) : undefined,
    modified_date: mockup.modified_date ? new Date(mockup.modified_date) : undefined,
  }));
